import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const HeartSounds = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
      <Autocomplete
        value={moduleValues?.['Heart Sounds'] ?? []}
        options={[
            "Normal S1 and S2",
            "Split S1",
            "Split S2",
            "S3 (S3 Gallop)",
            "S4 (S4 Gallop)",
            "Murmur (Specify location and characteristics)",
            "Click (Specify location and characteristics)",
            "Rub (Pericardial friction rub)",
            "Other (Specify)",
        ]}
        multiple
        freeSolo
        onChange={(e, value) => setModuleValues(prev => ({...prev, ['Heart Sounds']: value}))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Heart Sounds"
          />
        )}
      />
    </Grid>

)

export default HeartSounds
